// Vite hands env values over as strings: only "true" turns a flag on.
export const isFlagOn = (value: unknown): boolean => String(value ?? '').trim().toLowerCase() === 'true'
